// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// VENDORS
import '@/vendors/bootstrap-datepicker/bootstrap-datepicker3.min.css'
//import '@/vendors/bootstrap-colorpicker/css/bootstrap-colorpicker.min.css'
import '@/vendors/stylesheets/oneui/bootstrap.min.css'
import '@/vendors/stylesheets/oneui/oneui.css'
import '../node_modules/element-ui/lib/theme-chalk/index.css';
// import '@/vendors/select2/select2.min.css'
// import '@/vendors/select2/select2-bootstrap.min.css'
//
// import '@/vendors/jquery/jquery.3.3.1.min.js'
import '@/vendors/oneui/oneui.min.js'
import '@/vendors/bootstrap-datepicker/bootstrap-datepicker.js'
import '@/vendors/moment-locale/fr-ca.js'
//import '@/vendors/bootstrap-colorpicker/bootstrap-colorpicker.js'
//import '@/vendors/bootstrap-colorpicker/bootstrap-colorpicker.min.js'





import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/stores'
import filters from '@/filters'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import lang from 'element-ui/lib/locale/lang/fr'
import locale from 'element-ui/lib/locale'



// configure language TODO: implement with i18n
locale.use(lang)

import '@/assets/stylesheets/global.sass'


// Date picker

Vue.config.productionTip = false

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['evauth-sosecure'] = 'ixmedia'
axios.defaults.baseURL = process.env.API_END_POINT

Vue.use(VueAxios, axios)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDONkBos7uKFL1aClosfH8WzPSaEozA0fw',
    libraries: 'places'
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js